import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import { createTheme, ThemeProvider } from '@mui/material/styles'
import hexToRgba from 'hex-to-rgba'
import ToastProvider from './components/organisms/ToastProvider/ToastProvider'
import Logo from '../src/assets/images/logo_vertical.png'

const MOUNT_NODE = document.getElementById('root')
const root = ReactDOM.createRoot(MOUNT_NODE)

const theme = createTheme({
  palette: {
    primary: { main: '#ce0707' },
    secondary: { main: '#66bb6a' }
  },
  breakpoints: {
    values: { xs: 0, sm: 600, md: 960, lg: 1280, xl: 1920 }
  }
})

// eslint-disable-next-line jest/require-hook
root.render(
  <ToastProvider theme={theme}>
    <ThemeProvider theme={theme}>
        <App/>
    </ThemeProvider>
  </ToastProvider>,
)
